import React, { useEffect, useState } from 'react';
import { Box, Button, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { createBrand } from '../../utilities/brand-api-utils';
import { Brand } from '../../models/brand';
import store from '../../store';

interface BrandDialogProps {
  brands: Array<Brand>,
  setDialog(open: boolean, update?: boolean): void;
}

function BrandDialog({ brands, setDialog }: BrandDialogProps) {
  interface BrandError {
    error: boolean,
    msg: string
  }
  const noError = {error: false, msg: ''};
  const [brandName, setBrandName] = useState<string>('');
  const [brandError, setBrandError] = useState<BrandError>(noError);

  const addBrand = async () => {
    if (!brandError.error) {
      // API call ot add a new brand and set the default files here
      const response = await createBrand(store.getState().authorization.cloudKey, brandName);
      const reqStatus = response.request.status;
      const reqMessage = response.request.response;

      if (reqStatus !== 400) {
        setDialog(false, true);
      } else {
        const error = {error: true, msg: reqMessage};
        setBrandError(error);
        // setBrandName('');
      }
    }
  };

  const onSetBrandName = async (value: string) => {
    if (value !== brandName) {
      setBrandError(noError);
    }

    setBrandName(value);
  }

  return (
    <Box height='100%'>
      <DialogTitle
        display='flex'
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          height: '100px',
          width: '100%'
        }}>
        <div style={{
            fontWeight: '500',
            color: '#121F35',
            fontSize: '40px'
          }}>
          Add Brand
        </div>
        <Button 
          sx={{
            borderRadius: '5px',
            width: 'auto',
            height: 'auto',
            padding: '0',
            minWidth: '0',
            '&:hover': {
              opacity: '.5',
            }
          }}
          onClick={() => {
            setDialog(false);
          }}>
          <CloseIcon
            sx={{
              padding: '0',
              fontSize: '2rem',
              color: '#121F35',
              width: '40px',
              height: '40px',
            }} />
        </Button>
      </DialogTitle>
      <DialogContent 
        sx={{
          height: '400px',
        }}>
        <Stack height='100%' display='flex' direction='column' justifyContent='center' alignItems='center' spacing={3}>
          <Typography variant='h5'>
            Enter Brand Name
          </Typography>
          <TextField
            inputProps={{ maxLength: 24 }}
            sx={{width: '300px'}} 
            value={brandName} 
            error={brandError.error}
            helperText={brandError.msg}
            onChange={(e) => onSetBrandName(e.target.value)}/>
          <Button 
            variant='contained' 
            size='large'
            disabled={brandError.error || (brandName.length < 1)}
            onClick={() => addBrand()}>
            Submit
          </Button>
        </Stack>
      </DialogContent>
    </Box>
  );
}

export default BrandDialog;
